export const siteKey = {
  V2: '6LcwsQsUAAAAAMFn9B9UoY5qTEWrdoBw6lIKPbvH',
  V3: '6LfTXNAZAAAAAJdBAE3g4JJKuSOli0YCss1dxdv4',
};
